import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface Banner {
  id: string;
  title: string;
  image_url: string | null;
  link_url: string | null;
  location: 'top' | 'sidebar' | 'article' | 'footer' | 'popup';
  is_active: boolean;
  display_order: number;
  banner_type: 'image' | 'code';
  code_content: string | null;
  start_date: string | null;
  end_date: string | null;
  created_at: string;
  updated_at: string;
  created_by: string | null;
}

export const useBanners = (location?: string, includeInactive = false) => {
  return useQuery({
    queryKey: ['banners', location, includeInactive],
    queryFn: async () => {
      let query = supabase.from('banners').select('*');

      if (location) {
        query = query.eq('location', location);
      }

      if (!includeInactive) {
        query = query.eq('is_active', true);
        
        // Filter by scheduling dates
        const now = new Date().toISOString();
        query = query.or(`start_date.is.null,start_date.lte.${now}`)
                     .or(`end_date.is.null,end_date.gte.${now}`);
      }

      query = query.order('display_order', { ascending: true });

      const { data, error } = await query;

      if (error) {
        console.error('Error fetching banners:', error);
        throw error;
      }

      return data as Banner[];
    },
    staleTime: 60000, // 1 minute
  });
};
